import Img from "react-cloudimage-responsive";
import LayoutMaster from "../../components/layout/layout_master";
import SMPointView from "components/view/smpoint_view";
import { MaxButton } from "components/view/button";
import { useState } from "react";
import RpsRoom from "components/rps/rps_room";
import { useEffect } from "react";
import rps_game_bet, { RPSGameBetResponse } from "lib/worker/api/rps_game_bet";
import rps_created_room from "lib/worker/api/rps_created_room";
import { CenterProps } from "lib/all_type/center_props";
import getinfo, { GetInfoResponse } from "lib/worker/api/getinfo";
import { useToasts } from "react-toast-notifications";
import get_transaction_rps_room, {
  GetTransactionRPSRoomRepsonse,
} from "lib/worker/api/get_transaction_rps_room";
import { pusher } from "components/PusherEvent";
import { AppReducerStateProps } from "lib/store";
import { connect } from "react-redux";
import RpsHowToModal, {
  showRpsHowtoModal,
} from "components/modal/rps_howto_modal";
import get_transaction_rps_my_room from "lib/worker/api/get_transaction_rps_my_room";
import HistoryRpsShow from "components/view/history_rpg_show";
import { GetServerSideProps } from "next";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";

export type ToggleStateRPS = "otherroom" | "myroom";

export interface SelectRps {
  id: number;
  rps: string;
  rpsimgs: string;
  spinner?: boolean | undefined;
}

export interface OnHoldLoadBet {
  hashkey: string;
  selectRps: SelectRps;
}

export interface URPSProps extends CenterProps {
  getinfo: GetInfoResponse;
  isLogin: boolean;
  infomation: CheckWithPrefixResponse;
}

function URPSPage(props: URPSProps) {
  const [rooms, setRoom] = useState<GetTransactionRPSRoomRepsonse[]>([]);
  const [myRooms, setMyRooms] = useState<GetTransactionRPSRoomRepsonse[]>([]);
  const [bets, setBets] = useState<RPSGameBetResponse[]>([]);
  const [toggleState, setToggleState] = useState<ToggleStateRPS>("otherroom");
  const [rps] = useState<SelectRps[]>([
    {
      id: 1,
      rps: "r",
      rpsimgs: "rock-card.png",
    },
    {
      id: 3,
      rps: "p",
      rpsimgs: "paper-card.png",
    },
    {
      id: 2,
      rps: "s",
      rpsimgs: "ssci-card.png",
    },
  ]);

  const [selectBet, setSelectBet] = useState<RPSGameBetResponse | null>();
  const [selectRps, setSelectRps] = useState<SelectRps | null>();
  const [betLoading, setBetLoading] = useState<boolean>(false);
  const { addToast } = useToasts();
  const [onHoldLoadBet, setOnHoldLoadBet] = useState<OnHoldLoadBet[]>([]);

  const toggleTab = (index: ToggleStateRPS) => {
    setToggleState(index);
  };

  const displayRoomToggleTap = (): JSX.Element | undefined => {
    switch (toggleState) {
      case "otherroom":
        if (selectBet == null) {
          return (
            <div className="container bg-blue border-radius margin-top-10">
              <p
                className="text-center font-red"
                style={{ paddingTop: 20, paddingBottom: 20 }}
              >
                ท่านยังไม่ได้เลือกห้อง
              </p>
            </div>
          );
        }

        if (rooms.length == 0) {
          return (
            <div className="container bg-blue border-radius margin-top-10">
              <p
                className="text-center font-red"
                style={{ paddingTop: 20, paddingBottom: 20 }}
              >
                ห้องนี้ยังว่างอยู่
              </p>
            </div>
          );
        }
        return (
          <div className="margin-top-10">
            <div className="row wrapper">
              {rooms.map((value, i) => (
                <RpsRoom
                  key={i}
                  room={value}
                  rpsroom={[
                    {
                      id: 1,
                      rps: "r",
                      rpsimgs: "rock-bg.png",
                      spinner: false,
                    },
                    {
                      id: 3,
                      rps: "p",
                      rpsimgs: "paper-bg.png",
                      spinner: false,
                    },
                    {
                      id: 2,
                      rps: "s",
                      rpsimgs: "ssci-bg.png",
                      spinner: false,
                    },
                  ]}
                  onLoading={onLoading}
                  onHoldLoadBet={onHoldLoadBet}
                ></RpsRoom>
              ))}
            </div>
          </div>
        );
      case "myroom":
        return (
          <div>
            {" "}
            {(myRooms ?? []).map((value) => {
              return (
                <>
                  <HistoryRpsShow
                    Name={value.Username}
                    Amount={value.Amount}
                    Time={value.DisplayCreatedAt}
                    loading={betLoading}
                  ></HistoryRpsShow>
                </>
              );
            })}
          </div>
        );
    }
  };

  useEffect(() => {
    rps_game_bet().then((json) => {
      setBets(json);
    });
  }, []);

  useEffect(() => {
    if (!props.isLogin) {
      return;
    }

    const channelRpsRoomReward = pusher.subscribe(
      "private-client-my-channel-reload-rps-room-reward-" +
        `${props.getinfo.Username ?? ""}`
    );

    channelRpsRoomReward.bind(`reload`, (data: string) => {
      reloadMyRooms();
      if (data.includes("คุณแพ้")) {
        addToast(data, {
          appearance: "error",
          autoDismiss: true,
        });
      } else {
        addToast(data, {
          appearance: "success",
          autoDismiss: true,
        });
      }
    });

    reloadMyRooms();

    return () => {
      channelRpsRoomReward.unbind_all();
      channelRpsRoomReward.disconnect();
    };
  }, []);

  const reloadMyRooms = () => {
    get_transaction_rps_my_room()
      .then((json) => {
        setMyRooms(json);
      })
      .catch((error) => {
        props.alertWithMessage(error.response.data.message);
      });
  };

  useEffect(() => {
    const reload = () => {
      get_transaction_rps_room({ transaction_rps_game_bet_id: selectBet?.ID })
        .then((json) => {
          setRoom(json);

          if (!props.isLogin) {
            return;
          }

          getinfo();
        })
        .catch((error) => {
          props.alertWithMessage(error.response.data.message);
        });
    };

    const channelRpsRoom = pusher.subscribe(
      "private-client-my-channel-reload-rps-room-" + `${selectBet?.ID ?? 0}`
    );

    channelRpsRoom.bind(`reload`, () => {
      reload();
    });

    reload();

    return () => {
      channelRpsRoom.unbind_all();
      channelRpsRoom.disconnect();
    };
  }, [selectBet]);

  const createRoom = () => {
    if (!props.isLogin) {
      props.alertWithMessage("กรุณาเข้าสู่ระบบ ถึงจะสามารถเล่นเกมได้");
      return;
    }

    setBetLoading(true);
    rps_created_room({ bet_id: selectBet?.ID, bet_result_id: selectRps?.id })
      .then(() => {
        getinfo();
        addToast("สร้างห้องเกมเป่ายิ้งฉุบสำเร็จ", {
          appearance: "success",
          autoDismiss: true,
        });
      })
      .finally(() => {
        setBetLoading(false);
        reloadMyRooms();
      })
      .catch((error) => {
        props.alertWithMessage(error.response.data.message);
      });
  };

  const onClickBet = (value: RPSGameBetResponse | undefined) => {
    if (selectBet != null && selectBet.ID == value?.ID) {
      setSelectBet(null);
    } else {
      setSelectBet(value);
    }
  };

  const onClickRps = (value: SelectRps | undefined) => {
    if (selectRps != null && selectRps.rps == value?.rps) {
      setSelectRps(null);
    } else {
      setSelectRps(value);
    }
  };

  const onLoading = (
    hashKey: string,
    isLoading: boolean,
    selectRps: SelectRps
  ): void => {
    if (isLoading) {
      setOnHoldLoadBet([
        ...onHoldLoadBet,
        { hashkey: hashKey, selectRps: selectRps },
      ]);
    } else {
      for (let index = 0; index < onHoldLoadBet.length; index++) {
        const element = onHoldLoadBet[index];
        if (hashKey == element.hashkey) {
          onHoldLoadBet.slice(index, 1);
          break;
        }
      }
    }
  };

  return (
    <LayoutMaster
      content_setting={{
        title: "เกมเป่ายิ้งฉุบ แย่งชิงเงินรางวัล uDiamond",
        description:
          "เกม เป่า ยิ้ง ฉุบ แย่งชิง เงินรางวัล uDiamond เกมยอดนิยม ในประเทศไทย ที่ใครๆ ก็รู้จัก ท้าประลองชิง uDiamond จากฝ่ายตรงข้าม และกิจกรรมอื่นๆ อีกมากมาย",
      }}
      information={props.infomation}
    >
      <div className="container" style={{ paddingTop: 20 }}>
        <h1 className="text-center">
          <span>เกมเป่ายิ้งฉุบ</span>
        </h1>
        <div className="text-center">
          <SMPointView></SMPointView>
        </div>
        <div className="row wrapper center-row-content col-12 col-md-8 col-lg-6">
          {rps.map((value, i) => (
            <div
              key={i}
              onClick={() => {
                onClickRps(value);
              }}
              className={`col-4 margin-top-10 grid select-div ${
                selectRps && selectRps.rps == value.rps ? "" : ""
              }`}
            >
              <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                <Img
                  ratio={0.75 / 1}
                  className={` ${
                    selectRps && selectRps.rps == value.rps
                      ? "button-glowing"
                      : ""
                  }`}
                  src={value.rpsimgs ?? ""}
                  alt={value.rpsimgs}
                ></Img>
              </div>
            </div>
          ))}
        </div>
        <h2 className="text-center font-bold">เลือกราคา</h2>
        {bets.map((value, i) => (
          <button
            key={i}
            onClick={() => {
              onClickBet(value);
            }}
            className={`row center-row-content col-md-3 col-4 btn btn-choose-money" ${
              selectBet && selectBet.ID == value.ID
                ? "btn-choose-money-submit"
                : "btn-choose-money-rps"
            }`}
          >
            <div className={"font-base margin-top-10 margin-bottom-10"}>
              <span style={{ fontSize: 14 }}>
                {value.Amount?.format(0, 0)} uDiamond
              </span>
            </div>
          </button>
        ))}
        <div className="row center-row-content wrapper">
          <div className="margin-top-20 col-8 grid">
            <MaxButton
              title="สร้างห้องเดิมพัน"
              className="text-center bg-invite button-glowing"
              onClick={createRoom}
              loading={betLoading}
            ></MaxButton>
          </div>
          <div className="margin-top-20 col-4 grid">
            <MaxButton
              title="วิธีเล่น"
              className="text-center btn-how-rps margin-left-5"
              onClick={showRpsHowtoModal}
            ></MaxButton>
          </div>
          <RpsHowToModal></RpsHowToModal>
        </div>
        <div
          className="margin-top-20 color-font-card"
          style={{ textAlign: "center" }}
        >
          <label className="text-center">
            <div className="row">
              <div
                className={
                  "otherroom" == toggleState
                    ? "bg-room-left-active"
                    : "bg-room-left"
                }
                onClick={() => toggleTab("otherroom")}
              >
                ห้อง {selectBet?.Amount?.format(0, 0)}
              </div>

              <div
                className={
                  "myroom" == toggleState
                    ? "bg-room-right-active"
                    : "bg-room-right"
                }
                onClick={() => toggleTab("myroom")}
              >
                ห้องของฉัน
              </div>
            </div>
          </label>
        </div>
        <div>{displayRoomToggleTap()}</div>
      </div>
    </LayoutMaster>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    getinfo: state.member.getinfo,
    isLogin: state.member.isLogin,
  };
};

export default connect(mapStateToProps)(URPSPage);
